import io from "socket.io-client";

export const socketio = {
    methods : {
        /**
         * initialize socket io
         * connect to socket io server
         */
        initsocket() {
            const socket = io(process.env.VUE_APP_SOCKETIOURL);

            socket.on("connect", () => {
                console.log('connected', socket.connected); // true

                this.$store.commit('updatesocketio', socket)
            });

        }
    }
}